import styled, { css } from 'styled-components';

export const CardWrapper = styled.div(
  ({ theme }) => css`
    position: relative;
    width: 100%;
    padding: ${theme.sz.s6} ${theme.sz.s4};
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s3};
    background: ${theme.co.neutral99};
    border: ${theme.bo.mediumWidth} solid ${theme.co.neutral90};
    border-radius: ${theme.bo.mediumLarge};
  `,
);

export const CardOverlay = styled.div(
  () => css`
    position: absolute;
    inset: 0;
    z-index: 1;
    cursor: pointer;
  `,
);

export const Header = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s2};
    font-size: ${theme.sz.s6};
    color: ${theme.co.secondary20};
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxs};
    color: ${theme.co.secondary20};
    flex-grow: 1;
  `,
);

export const ArrowButton = styled.a(
  ({ theme }) => css`
    font-size: ${theme.sz.s5};
    color: ${theme.co.secondary0};
    text-decoration: none;
    display: inline-flex;

    &:hover {
      color: ${theme.co.secondary50};
    }
  `,
);
